module.exports = __webpack_public_path__ + "static/buildingSmart-eade44cfaebab24a7c542718aedc2357.png";